const TipoAtendimento = {
    FLUXO: 1,
    CHAMADO: 2,
    ATENDIMENTO: 3
};

export default TipoAtendimento;
